import { fontOpenSans } from "./font-family/fonts/open-sans";
import { fontSize, typographyBase } from "./typography-base";

export { fontSize };
export const typography = {
  ...typographyBase,
  fontFamily: fontOpenSans.style.fontFamily,
};
